// DealRun is French-only: texts are written in French in the code; t() only translates values coming from the data.
const FR = {
  Exclusive: 'Exclusif', 'Last chance': 'Dernière chance', New: 'Nouveau', Promo: 'Promo',
};

export const getLang = () => 'fr';
export const setLang = () => {};
export const t = (s) => FR[s] ?? s;

document.documentElement.lang = 'fr';
document.documentElement.dir = 'ltr';
localStorage.removeItem('dealrun_lang');
